var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redial-call"},[_c('div',{staticClass:"text"},[_vm._v("Presionar el boton para llamar")]),_c('div',{staticClass:"call-button",attrs:{"tabindex":"0"},on:{"click":_vm.redial}},[_c('svg',{staticClass:"call-key",attrs:{"width":"44","height":"44"}},[_c('use',{attrs:{"href":'/icons.svg#call-button'}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }